import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../utils/axios";
import { setPurchaseToken } from "../redux/slices/giftCardSlice";

export const getAllGiftCards = createAsyncThunk(
  "giftCard/getAll",
  async ({ page = 1, limit = 10, token }, thunkAPI) => {
    try {
      // attach the token that mobile dev gave you
      const response = await axios.get(
        `giftCard/get-all-cardDetail?page=${page}&limit=${limit}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("response",response)

      // save token in Redux for later use (like purchaseGiftCard)
      if (token) {
        thunkAPI.dispatch(setPurchaseToken(token));
      }
      console.log("token",token);

      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);


export const getGiftCardById = createAsyncThunk(
  "giftCard/getById",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(`giftCard/${id}`);
      return response?.data?.data || null;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);
export const purchaseGiftCard = createAsyncThunk(
  "giftCard/purchase",
  async (payload, thunkAPI) => {
    try {
      const { token, ...restPayload } = payload;
      const response = await axios.post(`giftCard/purchase`, restPayload, {
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      });

      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const lookupGiftCard = createAsyncThunk(
  "giftCard/lookup",
  async (sessionId, { rejectWithValue }) => {
    try {
        const cleanId = sessionId?.replace(/^:/, "").trim(); 
      const { data } = await axios.get(`/giftCard/lookup/${cleanId}`);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to fetch");
    }
  }
);
